import { Reducer, useReducer } from "react";
import Action from "types/Action";

// 상태 업데이트 커스텀 훅
const useInput = <T>(initialState: T) => {
  const reducer = (state: T, action: Action) => {
    const { event, option, reset, objectState } = action;

    if (event) {
      const { name, value } = event.target;
      return { ...state, [name]: value };
    }

    if (option) {
      return { ...state, [option.key]: option.value };
    }

    if (reset) {
      return { ...initialState };
    }

    if (objectState) {
      return { ...initialState, ...objectState };
    }

    return { ...state };
  };

  const [state, dispatch] = useReducer<Reducer<T, Action>>(
    reducer,
    initialState
  );

  return [state, dispatch] as const;
};

export default useInput;
